<template>
  <div class="mb-5">
    <vs-table :data="entries" maxHeight="60vh">
      <template slot="thead" >
        <th class="qb-sticky" v-if="hasPermission(['IU REVIEW ORDER EDIT'])"></th>
        <th class="qb-sticky">
          {{ $tc('entry') | capitalize }}
        </th>
        <th class="qb-sticky">
          {{ $t('client') | capitalize }}
        </th>
        <th class="qb-sticky">
          {{ $tc('po_number') | capitalize }}
        </th>
        <th class="qb-sticky">
          {{ $tc('container', 2) | capitalize }}
        </th>
        <th class="qb-sticky">
          {{ $t('weight') | capitalize }}
        </th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td :style="{ width: '2vw' }"  v-if="hasPermission(['IU REVIEW ORDER EDIT'])">
            <feather-icon
              @click="clickDeleteEntry(data[i].id)"
              icon="TrashIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              color="danger"
            />
          </vs-td>
          <vs-td>
            {{ data[i].entry_id }}
          </vs-td>
          <vs-td>
            {{ data[i].client_short_name }}
          </vs-td>
          <vs-td>
            {{ data[i].PO_number }}
          </vs-td>
          <vs-td>
            {{ data[i].container_string }}
          </vs-td>
          <vs-td> {{ data[i].weight }} {{ data[i].unit }} </vs-td>
        </vs-tr>
      </template>
    </vs-table>


    <vs-row vs-justify="flex-end" class="my-5">
      <vs-col vs-lg="4" vs-xs="7">
        <!-- vs-offset-xs="5" vs-xs="7" -->
        <vs-row class="mt-2">
          <vs-col vs-w="12" :style="{ borderTop: '#ededed solid 1px' }">
            Total Weight: {{ totals.weight }}
          </vs-col>
        </vs-row>
        <vs-row class="mt-2">
          <vs-col vs-w="12" :style="{ borderTop: '#ededed solid 1px' }">
            Total Containers: {{ totals.packs }}
          </vs-col>
        </vs-row>
        <vs-row class="mt-2">
          <vs-col vs-w="12" :style="{ borderTop: '#ededed solid 1px' }">
            Total Entries: {{ Object.keys(entries).length }}
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>


    <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
        <p>{{$t('are_you_sure_that_you_want_to_continue')}}</p>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-4"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
             ref="loadableButton" 
             id="link-button-loading" 
             class="w-full vs-con-loading__container" 
              color="primary"
              type="filled"
              :disabled="disabled_buttons"
              @click="confirmSubmit"
              >{{$t('i_am_sure')}}</vs-button
            >

          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              :disabled="disabled_buttons"
              @click="confirmActive = false"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>

  </div>
</template>

<script>
import reviewOrder from '@/http/requests/reviewOrder'
export default {
  components: {
  },
  computed: {
  },
  props: {
    reviewOrderId: {
      type: String,
      required:true
    },
    entries: {
      type: Array,
      default: () => { }
    },
    totals: {
      type: Object,
      default: {
        packs: '0',
        weight: '0 lb'
      }
    }
  },
  data() {
    return {
        confirmActive:false,
        disabled_buttons:false,
        entryId:''
    }
  },
  mounted() {
  },
  methods: {
    clickDeleteEntry(entry_id) {
      this.entryId=entry_id
      this.confirmActive=true
    },
    confirmSubmit(){
      this.disabled_buttons=true
      this.$emit('loadingSubmit',this.disabled_buttons)
      let params={
        entry_id:this.entryId,
        review_order_id:this.reviewOrderId
      }
      reviewOrder.deleteEntries(params).then(res=> {
        this.disabled_buttons=false
        this.$emit('loadingSubmit',this.disabled_buttons)
        this.$emit('itemRemoved')
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Guardado'
        })
        this.confirmActive=false
      }).catch(err=> {
        console.log(err)
        this.disabled_buttons=false
        this.$emit('loadingSubmit',this.disabled_buttons)
        this.confirmActive=false
      })
    },
    showDetails(id){
      let routeData = this.$router.resolve({
        name: 'entry-details',
        params: {
          id: id
        }
      })
      window.open(routeData.href, '_blank');  
    }
  }
}
</script>
